export default "__VITE_ASSET__CExdSSxu__"